import { render, staticRenderFns } from "./addPriModal.vue?vue&type=template&id=0fee156e"
import script from "./addPriModal.vue?vue&type=script&lang=js"
export * from "./addPriModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports